@if(isTfaConfigured) {
<div
  class="flex justify-content-center align-items-center otp-container mt-3"
>
  <div class="flex flex-column">
    <div class="text-grey-900 my-2 text-2xl">Verification code</div>
    <p class="text-sm text-color-secondary mb-3 mt-0 p-0">
      Please enter the verification code from your authenticator app
    </p>
    <p-inputOtp
      [length]="6"
      (onChange)="verifyOTPChange($event)"
      [(ngModel)]="tfaOtp"
      [integerOnly]="true"
    />

    <div
      (click)="backToLoginPage()"
      class="mt-3 text-color-secondary cursor-pointer p-0 text-xs underline"
    >
      Back to login page
    </div>
  </div>
</div>
} @else {
<div
  class="flex flex-column gap-2 justify-content-center"
>
  <div class="text-grey-900 text-2xl my-2">
    Two factor authentication setup
  </div>

  <div>
    <p class="text-sm text-color font-medium m-0 p-0">Step 1</p>
    <p class="text-color-secondary text-xs m-0 p-0">
      Install a two-factor authentication app on your device
    </p>
  </div>

  <div>
    <p class="text-color text-sm m-0 font-medium p-0">Step 2</p>
    <p class="text-color-secondary m-0 text-xs p-0">
      Open your preferred two-factor authentication app on your phone and scan the following QR code.
    </p>
  </div>

  @if(tfaInputData?.dataURL) {
    <img [src]="tfaInputData?.dataURL" class="w-8rem" alt="QR Code" />
  } @else {
    <div class="spinner">
      <svg viewBox="25 25 50 50">
        <circle r="20" cy="50" cx="50"></circle>
      </svg>
    </div>
  }

  <p class="text-color-secondary text-xs m-0 p-0">
    if you are unable to scan the QR code, please enter the secret key manually
    :
    <span class="text-color text-sm flex align-items-center gap-2">
      {{ tfaInputData?.tempSecret }}
      <app-copy-content size="0.875rem" [content]="tfaInputData?.tempSecret" />
    </span>
  </p>

  <div>
    <p class="text-color text-sm m-0 font-medium p-0">Step 3</p>
    <p class="text-color-secondary text-xs m-0 p-0">
      Enter the two-factor authentication code displayed in your mobile application to confirm and
      enable authentication for your account
    </p>
  </div>
  <div class="otp-container">
    <p-inputOtp
      [length]="6"
      (onChange)="verifyOTPChange($event)"
      [(ngModel)]="tfaOtp"
      [integerOnly]="true"
    />
    <p-button
      (onClick)="verifyOTP()"
      [disabled]="tfaOtp.length < 6 || isVerifying"
      class="w-full text-xs"
    >
      Verify @if (isVerifying) {
      <i class="pi pi-spin pi-spinner text-sm ml-2"></i>
      }
    </p-button>
  </div>
</div>
}
